import FileSaver from "file-saver";

export function takeExcelFile(data) {
  var fileName = getFileNameFromHeaders(data.headers);

  data.blob().then((dataAsBlob) => {
    FileSaver.saveAs(dataAsBlob, fileName);
  });
}

const getFileNameFromHeaders = (headers) => {
  try {
    return headers
      .get("content-disposition")
      .split(";")
      .find((f) => f.includes("filename="))
      .split("filename=")[1];
  } catch {
    return "UnknownFileName";
  }
};
